import { axios_legacy as axios, axios as axios_new_api } from '@/store/config';

import VueAxios from 'vue-axios';
import _ from 'lodash';
import auth from '@/auth/index';
import configs from '../config.js';

export default {
  // state
  state: {
    invoices: [],
  },
  // getters
  getters: {
    invoices: (state) => state.invoices,

    getInvoiceById: (state) => (Id) => {
      return state.invoices.find((invoice) => singelObject.id == Id);
    },

    hasInvoices(state) {
      if (!Array.isArray(state.invoices)) return false;

      return !!state.invoices.length;
    },
  },

  // actions/**/
  actions: {
    fetchInvoices({ commit, rootState }) {
      return axios_new_api
        .get('/invoices/get', {
          validateStatus: (status) => {
            // Alla användare har inte fakturor, vilket ska vara OK
            if (status == 200 || status == 404) return true;
          },
        })
        .then((response) => {
          let activeInvoices = response.data.sort((a, b) => {
            return new Date(b.ExpireDate) - new Date(a.ExpireDate);
          });
          if (response.status == 404) commit('setInvoices', []);
          else {
            commit('setInvoices', activeInvoices);
          }
        });
    },
  },

  // mutations
  mutations: {
    setInvoices(state, invoices) {
      state.invoices = invoices;
    },
  }
};
